<template>
  <div>
    <NavBar v-if="$route.meta.showNav"  />
    <router-view></router-view>
  </div>
</template>

<script>
import NavBar from "../../components/MyNavBar.vue";

export default {
  name: "UserIndex",
  components: {
    NavBar,
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
</style>